import { useSelector } from "react-redux";
import { Spinner } from "./spinner";

const Loader = ({ isMinified }) => {
  var loading = useSelector((state) => state.sceneVisibility.loading);
  var windIsLoading = useSelector((state) => state.windDirection.isLoading);
  var windRiskIsLoading = useSelector(
    (state) => state.shadingSystem.windRiskIsLoading,
  );
  const windTurbineIsLoading = useSelector(
    (state) => state.windTurbine.windTurbineIsLoading,
  );
  const pVDataIsLoading = useSelector((state) => state.pvData.pVDataIsLoading);
  const daylightIsLoading = useSelector(
    (state) => state.daylightFactor.daylightIsLoading,
  );
  const sensorPlacementIsLoading = useSelector(
    (state) => state.shadingSystem.sensorPlacementIsLoading,
  );
  const windAlarmSensorsIsLoading = useSelector(
    (state) => state.shadingSystem.windAlarmSensorsIsLoading,
  );
  const windAlarmWindowsIsLoading = useSelector(
    (state) => state.shadingSystem.windAlarmWindowsIsLoading,
  );
  const shadingProgressionIsLoading = useSelector(
    (state) => state.shadingSystem.shadingProgressionIsLoading,
  );
  const sunMovementIsLoading = useSelector(
    (state) => state.shadingSystem.sunMovementIsLoading,
  );
  var sensorIsLoading = useSelector((state) => state.sensorSolars.isLoading);

  const someIsLoading = loading.some((e) =>
    Array.isArray(e) ? e.some(Boolean) : e,
  );
  if (someIsLoading)
    return (
      <Spinner title="Building model..." size={isMinified ? "sm" : "lg"} />
    );
  else if (
    sensorIsLoading ||
    windIsLoading ||
    windTurbineIsLoading ||
    windRiskIsLoading ||
    pVDataIsLoading ||
    daylightIsLoading ||
    sensorPlacementIsLoading ||
    windAlarmSensorsIsLoading ||
    windAlarmWindowsIsLoading ||
    shadingProgressionIsLoading ||
    sunMovementIsLoading
  )
    return <Spinner title="Loading data..." size={isMinified ? "sm" : "lg"} />;
};
export default Loader;
